<template>
	<vs-table :max-items="10" pagination :data="listAnswer">
		<template slot="thead">
			<vs-th class="w-1/4">
				{{ $t('siteChatResponseTemplatesName') }}
			</vs-th>
			<vs-th class="w-2/4">
				{{ $t('siteChatResponseTemplatesTemplate') }}
			</vs-th>
			<vs-th class="w-1/4">
				{{ $t('actions') }}
			</vs-th>
		</template>

		<template slot-scope="{data}">
			<vs-tr :key="indextr" v-for="(tr, indextr) in data">
				<vs-td :data="data[indextr].templateName">
					{{ data[indextr].templateName }}
				</vs-td>
				<vs-td :data="data[indextr].templateTemplate">
                    <div v-html="short(data[indextr].templateTemplate, 150)">
                    </div>
				</vs-td>
				<vs-td :data="data[indextr].templateId">
                    <div class="flex justify-center">
                        <vs-button
                            size="small"
                            color="#626262"
                            type="flat"
                            icon-pack="feather"
							@click="websiteAnswer=currentWebsiteChatTemplate(data[indextr].templateId); editChatResponseActive = true"
                            icon="edit"
                        >
                            <feather-icon icon="EditIcon"></feather-icon>
                        </vs-button>
                    </div>
                </vs-td>        
			</vs-tr>
            <EditSiteChatResponseTemplate
                :active.sync="editChatResponseActive"
                :websiteAnswer="websiteAnswer"
                @confirm="setSiteChatResponseTemplate"
            />
		</template>
	</vs-table>
    
</template>

<script>
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";
    import EditSiteChatResponseTemplate from "@/components/dialogs/EditSiteChatResponseTemplate";

    export default {
        name: "SiteChatResponseTemplate",
        mixins: [databaseManager, notifier],
        props: {
            model: { required: true },
        },
        components: {
            EditSiteChatResponseTemplate,
        },
        data() {
            return {
                listAnswer: {},
                editChatResponseActive: false,
                websiteAnswer: null,
            };
        },
        methods: {
            short(str, maxlen) {
                str = str.replace(/(<([^>]+)>)/gi, '');
                if(str.length <= maxlen) {
                    return str;
                } else {
                    return str.slice(0, maxlen) + ' ...'
                }
            },
            // short: (str, maxlen) => str.length <= maxlen ? str : str.slice(0, maxlen) + ' ...',
            async loadAnswerTempate() {
                try {
                    this.listAnswer = await this.dbWebsiteGetChatResponse(this.model.id);
                } catch(e) {
                    this.notifyError(e.message);
                }
            },
            openItemEditAnswer() {
                this.editChatResponseActive = true;
            },
            currentWebsiteChatTemplate(id) {
                const current = this.listAnswer.find(item => item.templateId === id);
                return current !== -1 ? current : null;
            },
            async setSiteChatResponseTemplate(chatTemplateAnswer) {
                try{
                    await this.dbWebsiteSetChatResponseTemplate(chatTemplateAnswer.templateId, chatTemplateAnswer);
                    this.notifySuccess(`${this.$t('siteAutoEmailTemplateSuccess')}`);
                    this.$emit("updateSite");
                }catch (e) {
                    this.notifyError(e.message);
                }
            },
        },
        async mounted() {
            try {
                this.loadAnswerTempate();
            } catch(e) {
                this.notifyError(e.message);
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>